// Lazy loading for product images and Reviews.io initialization
document.addEventListener('DOMContentLoaded', function() {
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                const bgUrl = img.dataset.bg;
                
                // Check if image already has a background set (by immediate initialization or variant selection)
                const currentBgImage = img.style.backgroundImage;
                const hasImageSet = currentBgImage && currentBgImage !== '' && currentBgImage !== 'none';
                
                // Only load if no image is already set
                if (bgUrl && !hasImageSet) {
                    img.style.backgroundImage = `url('${bgUrl}')`;
                }
                
                img.removeAttribute('data-bg');
                observer.unobserve(img);
            }
        });
    });

    // Observe all product images that don't already have a background image set
    document.querySelectorAll('.category-product-image[data-bg]').forEach(img => {
        imageObserver.observe(img);
    });

    // Initialize Reviews.io widgets for category items
    initCategoryReviewsIOWidgets();
});

// Initialize Reviews.io widgets for category items
function initCategoryReviewsIOWidgets() {
    const ratingContainers = document.querySelectorAll('.product-rating[data-reviews-io-product-id]');
    
    if (ratingContainers.length === 0) return;

    // Check if Reviews.io script is already loaded
    if (window.ReviewsWidget) {
        ratingContainers.forEach(container => {
            createCategoryRatingWidget(container);
        });
    } else {
        // Load Reviews.io script
        const script = document.createElement('script');
        script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
        script.onload = function() {
            ratingContainers.forEach(container => {
                createCategoryRatingWidget(container);
            });
        };
        document.head.appendChild(script);
    }
}

function createCategoryRatingWidget(container) {
    const productId = container.getAttribute('data-reviews-io-product-id');
    const store = container.getAttribute('data-reviews-io-store');
    
    if (!productId || !store) {
        container.style.display = 'none';
        return;
    }

    try {
        // Create Reviews.io widget
        new ReviewsWidget({
            store: store,
            product: productId,
            widget: 'polaris',
            display_options: {
                show_rating: true,
                show_review_count: true,
                show_review_text: false,
                show_reviewer_name: false,
                show_reviewer_avatar: false,
                show_review_date: false
            },
            container: container
        });
    } catch (error) {
        console.log('Reviews.io widget error:', error);
        // Hide container if widget fails
        container.style.display = 'none';
    }
}
